<template>
    <CModal
      :title="title"
      :color="color"
      :show.sync="showModal"
      size="lg"
    >   
        <CForm id="document_form" method="POST" enctype="multipart/form-data">
          <CInput
            hidden
            :lazy="false"
            :value.sync="$v.form.id.$model"
            name="id"
            id="id"          
          />
          <CRow>
              <CCol md="8">
                <CInput
                  label="Nombre:"
                  :lazy="false"
                  :value.sync="$v.form.name.$model"
                  :isValid="checkIfValid('name')"
                  name="name"
                  id="name"
                  placeholder=""
                  autocomplete="given-name"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                />
              </CCol>
              <CCol md="4">
                <CInput
                  label="Código:"
                  :lazy="false"
                  :value.sync="$v.form.code.$model"
                  name="code"
                  id="code"
                  class="input_code"
                  placeholder=""
                  autocomplete="given-code"
                  disabled
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="8">
                <CInput
                  label="Descripción:"
                  :lazy="false"
                  :value.sync="$v.form.description.$model"
                  name="description"
                  id="description"
                  placeholder=""
                  autocomplete="given-description"
                />
              </CCol>
              <CCol md="4">
                <CInput
                  label="Código Anterior:"
                  :lazy="false"
                  :value.sync="$v.form.last_code.$model"
                  name="last_code"
                  id="last_code"
                  placeholder=""
                  autocomplete="given-last_code"
                  class="input_code"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="6">
                <CSelect
                    label="Tipo:"
                    :value.sync="$v.form.asset_type_id.$model"
                    :isValid="checkIfValid('asset_type_id')"
                    :options="typesOptions"
                    name="asset_type_id"
                    id="asset_type_id"
                    invalidFeedback="Este campo es requerido."
                  />                            
              </CCol>
              <CCol md="6">
                <CSelect
                  label="Departamento:"
                  :value.sync="$v.form.asset_departament_id.$model"
                  :isValid="checkIfValid('asset_departament_id')"
                  :options="departamentsOptions"
                  name="asset_departament_id"
                  id="asset_departament_id"
                  invalidFeedback="Este campo es requerido."
                />                              
              </CCol>
            </CRow>
            <CRow>
              <CCol md="8">
                <CInput
                  label="Proveedor:"
                  :lazy="false"
                  :value.sync="$v.form.supplier.$model"
                  name="supplier"
                  id="supplier"
                  placeholder=""
                  autocomplete="given-supplier"
                />
              </CCol>
              <CCol md="4">
                <CInput
                  label="No. Serie:"
                  :lazy="false"
                  :value.sync="$v.form.serie.$model"
                  name="serie"
                  id="serie"
                  placeholder=""
                  autocomplete="given-serie"
                />
              </CCol>
            </CRow>
            <CRow>         
              <CCol md="4">
                <CInput
                  label="No. Factura:"
                  :lazy="false"
                  :value.sync="$v.form.invoice.$model"
                  name="invoice"
                  id="invoice"
                  placeholder=""
                  autocomplete="given-invoice"
                />
              </CCol>
              <CCol md="4">
                <div role="group" class="form-group">
                  <label> Fecha Factura:</label>
                  <v-date-picker
                    class="date-picker"
                    v-model="$v.form.adquisition_date.$model"
                    locale="es-MX" size="sm"
                  />
                </div>
              </CCol>
              <CCol md="4">
                <CInput
                  label="Monto Factura:"
                  :lazy="false"
                  :value.sync="$v.form.adquisition_value.$model"
                  name="adquisition_value"
                  id="adquisition_value"
                  placeholder=""
                  autocomplete="given-serie"
                />
              </CCol>
            </CRow>
            <CRow>                             
              <CCol md="6">
                <CInput
                  label="Imagen 1:"
                  :lazy="false"
                  :value.sync="$v.form.image.$model"
                  type="file"
                  accept=".jpg,.jpeg,.png;capture=camera"
                  name="image"
                  id="image"
                  placeholder=""
                  autocomplete="given-image"
                />
              </CCol>                            
              <CCol md="6">
                <CInput
                  label="Imagen 2:"
                  :lazy="false"
                  :value.sync="$v.form.image2.$model"
                  type="file"
                  accept=".jpg,.jpeg,.png;capture=camera"
                  name="image2"
                  id="image2"
                  placeholder=""
                  autocomplete="given-image"
                />
              </CCol>     
            </CRow>
            <CRow>                             
              <CCol md="6">
                <CInput
                  label="Imagen 3:"
                  :lazy="false"
                  :value.sync="$v.form.image3.$model"
                  type="file"
                  accept=".jpg,.jpeg,.png;capture=camera"
                  name="image3"
                  id="image3"
                  placeholder=""
                  autocomplete="given-image"
                />
              </CCol>                             
              <CCol md="6">
                <CInput
                  label="Imagen 4:"
                  :lazy="false"
                  :value.sync="$v.form.image4.$model"
                  type="file"
                  accept=".jpg,.jpeg,.png;capture=camera"
                  name="image4"
                  id="image4"
                  placeholder=""
                  autocomplete="given-image"
                />
              </CCol>     
            </CRow>
            <CRow>
              <CCol md="12">
                <CInput
                  label="Observaciones:"
                  :lazy="false"
                  :value.sync="$v.form.observations.$model"
                  name="observations"
                  id="observations"
                  placeholder=""
                  autocomplete="given-observations"
                />
              </CCol>            
            </CRow>
            <CRow v-if="assignationEnabled">         
              <CCol md="12">
                <br /><h5>PERSONA ASIGNADA (RESGUARDO)</h5><br />
              </CCol>                                                             
            </CRow>
            <CRow v-if="assignationEnabled">         
              <CCol md="6">
                <div role="group" class="form-group">
                  <label> Fecha de Asignación:</label>
                  <v-date-picker
                    class="date-picker"
                    v-model="$v.form.asset_date.$model"
                    locale="es-MX" size="sm"
                  />
                </div>
              </CCol>                   
              <CCol md="6">
                <CSelect
                    label="Persona Asignada:"
                    :value.sync="$v.form.asset_person_id.$model"
                    :options="personsOptions"
                    invalidFeedback="Este campo es requerido."
                  />                            
              </CCol>                                                             
            </CRow>
            <CRow v-if="assignationEnabled">
              <CCol md="12">
                <CInput
                  label="Motivo o razón:"
                  :lazy="false"
                  :value.sync="$v.form.asset_description.$model"
                  placeholder=""
                  autocomplete="given-description"
                  invalidFeedback="Este campo es requerido."
                />
                <CInput
                :lazy="false"
                :value.sync="$v.form.asset_id.$model"
                hidden
              />
              </CCol>            
            </CRow>
        </CForm>
        <template #footer>
          <CButton v-if="!assignationEnabled && form.id == 0" style="position: absolute; left: 10px;" @click="assignationEnabled = true;" color="warning">Asignar Activo</CButton>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="store" :color="color">Aceptar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, minValue, helpers } from "vuelidate/lib/validators"
import ws_typ from '../../services/asset_types';
import ws_dep from '../../services/asset_departaments';
import ws_per from '../../services/asset_persons';

import { DatePicker } from 'v-calendar'
import moment from 'moment';
import moment_timezone from 'moment-timezone'

export default {
  name: 'AssetModal',
  props: {

  },
  components: {
    'v-date-picker': DatePicker
  },
  data () {
    return {
      showModal: false,
      title: "Nuevo Activo",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,      
      typesOptions: [],
      departamentsOptions: [],
      personsOptions: [],
      locationsOptions: [],
      assignationEnabled: false,
    }
  },
  mounted: async function() {    
    let response_typ = await ws_typ.get({ type: 'ASSETS' });
    if(response_typ.type == "success"){
      this.typesOptions = await this.$parseSelectOptionsOrdered(response_typ.data, "id", "name", [{"label": "","value":""}]);
    }
    let response_dep = await ws_dep.get();
    if(response_dep.type == "success"){
      this.departamentsOptions = await this.$parseSelectOptionsOrdered(response_dep.data, "id", "name", [{"label": "","value":""}]);
    }
    let response_per = await ws_per.get();
    if(response_per.type == "success"){
      this.personsOptions = await this.$parseSelectOptionsOrdered(response_per.data, "id", "name", [{"label": "","value":""}]);
    }

  },
  methods: {
    storeModal () {
      this.showModal = true;
      this.color = "info";
      this.title = 'Registro de Activo (Mueble)';
      this.isEdit = false;
      this.submitted = false;
      this.assignationEnabled = false;

      this.form = {
          id: 0,
          code: '-',
          last_code: '',
          name: '',
          description: '',
          observations: '',
          serie: "",
          image: "",
          asset_type_id: this.typesOptions.length ? this.typesOptions[0].value : "",
          asset_departament_id: this.departamentsOptions.length ? this.departamentsOptions[0].value : "",
          adquisition_date: new Date(),
          adquisition_value: '',
          supplier: '',
          invoice: '',
          asset_date: new Date(),
          asset_person_id: '',
          asset_description: '',
      }
    },
    updateModal (item) {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Editar Activo';
      this.isEdit = true;
      this.submitted = false;
      this.assignationEnabled = false;

      this.form = {
          id: item.id,
          code: item.code ? item.code : '',
          last_code: item.last_code ? item.last_code : '',
          name: item.name,
          description: item.description,
          observations: item.observations,
          serie: item.serie,
          image:"",
          asset_type_id: item.asset_type_id,
          asset_departament_id: item.asset_departament_id,
          asset_person_id: item.asset_person_id,
          adquisition_date: item.adquisition_date ? moment(item.adquisition_date,"YYYY-MM-DD").toDate() : new Date(),
          adquisition_value: item.adquisition_value > 0 ? item.adquisition_value : '',
          supplier: item.supplier ? item.supplier : '',
          invoice: item.invoice ? item.invoice : ''
      };
    },
    store () {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        let form = document.getElementById("document_form");
        let formData = new FormData(form);

        let date = this.form.adquisition_date;
        if(date != ""){
          date = moment(this.form.adquisition_date).format("YYYY-MM-DD");
        }

        formData.set("adquisition_date", date);

        let asset_date = this.form.asset_date;
        if(asset_date != ""){
          asset_date = moment(this.form.asset_date).format("YYYY-MM-DD");
        }

        formData.set("asset_date", asset_date);
        formData.set("asset_person_id", this.form.asset_person_id);
        formData.set("asset_description", this.form.asset_description);

        if(this.form.id > 0){
          this.$emit("update", formData );
        }
        else{
          this.$emit("store", formData );
        }

        this.closeModal();
      }
    },
    closeModal () {
      this.showModal = false;
      this.assignationEnabled = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          code: '',
          last_code: '',
          name: '',
          description: '',
          observations: '',
          serie: "",
          image: "",
          image2: "",
          image3: "",
          image4: "",
          asset_type_id: "",
          asset_departament_id: "",
          adquisition_date: new Date(),
          adquisition_value: '',
          supplier: '',
          invoice: '',
          asset_date: new Date(),
          asset_person_id: '',
          asset_description: '',
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      id: {        
      },
      name: {
        required,
        minLength: minLength(3)
      },
      description: {        

      },
      serie: {        

      },
      adquisition_date: {        

      },
      adquisition_value: {

      },
      image: {    

      },
      image2: {    

      },
      image3: {    

      },
      image4: {    

      },
      observations: {        

      },
      supplier: {        

      },
      invoice: {        

      },
      invoice_date: {        

      },
      last_code: {        

      },
      code: {        

      },
      asset_id: {        

    },
      asset_type_id: {
        required
      },
      asset_departament_id: {
        required
      },
      asset_date: {        

      },
      asset_person_id: {
        
      },
      asset_description: {
        
      },
    }
  },
}
</script>
<style>
  .input_code .form-control{
    text-align: center;
  }
</style>